import axios from "axios";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import OnboardingColor from "./OnboardingColor";
import OnboardingLogo from "./OnboardingLogo";
import OnboardingTerminado from "./OnboardingTerminado";

const OnboardingBienvenida = () => {
    const token = localStorage.getItem("token");
    const headers = {
        authorization: token,
    };
    const [empresa, setEmpresa] = useState({
        nombre: "",
        logo: "",
        color_primario: "#000000",
        color_secundario: "#000000",
    });
    const [page, setPage] = useState(0);
    const authUser = useSelector((state) => state.authReducer);
    const getEmpresa = async () => {
        const json = await axios.get(
            `${process.env.REACT_APP_PROXY}/empresas/detalle/${authUser.id_empresa}`,

            { headers }
        );

        console.log(json.data);
        setEmpresa({ ...json.data });
    };

    useEffect(() => {
        getEmpresa();
    }, []);
    const navigate = useNavigate();

    return (
        <div>
            {page === 0 && (
                <div className="w-full grid md723:grid-cols-2">
                    <div className="bg-[#333333] h-screen hidden md723:block">
                        <div className="mt-7 ml-8">
                            <svg
                                width="56"
                                height="56"
                                viewBox="0 0 56 56"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.5854 26.7736C13.8318 26.6672 14.024 26.516 14.164 26.3163C14.3022 26.1165 14.3712 25.8757 14.3712 25.5957C14.3712 25.1925 14.2294 24.8752 13.9419 24.6437C13.6563 24.4123 13.2699 24.2984 12.7846 24.2984H11.1288V26.9323H12.7379C13.0571 26.9323 13.339 26.88 13.5854 26.7736ZM14.7726 30.3128C14.7726 30.0029 14.6998 29.736 14.5542 29.512C14.4086 29.288 14.2032 29.1125 13.9382 28.9893C13.6712 28.8661 13.3539 28.8045 12.9806 28.8045H11.1307V31.668H12.9283C13.5592 31.668 14.024 31.5485 14.3246 31.3096C14.6214 31.0707 14.7726 30.7384 14.7726 30.3128ZM47.8798 31.3749C47.624 31.892 47.2712 32.3624 46.8251 32.7861C46.379 33.2099 45.8358 33.5477 45.1955 33.7979C44.5552 34.048 43.8216 34.1731 42.9947 34.1731C41.9064 34.1731 40.932 33.9323 40.0734 33.4544C39.2128 32.9747 38.5352 32.2765 38.0387 31.3563C37.5422 30.4379 37.292 29.3179 37.292 28C37.292 26.6784 37.544 25.5565 38.0499 24.6381C38.5558 23.7197 39.239 23.0197 40.0995 22.5437C40.9619 22.0659 41.927 21.8288 42.9947 21.8288C43.7227 21.8288 44.3966 21.9296 45.0163 22.1312C45.6342 22.3328 46.1792 22.6259 46.6496 23.0104C47.12 23.3968 47.5008 23.8691 47.7958 24.4291C48.0888 24.9891 48.2718 25.6275 48.3427 26.348H45.4064C45.3672 26.0475 45.287 25.7749 45.1656 25.5323C45.0443 25.2896 44.8838 25.0824 44.684 24.9107C44.4843 24.7389 44.2491 24.6064 43.9766 24.5149C43.704 24.4235 43.4035 24.3768 43.075 24.3768C42.4907 24.3768 41.9886 24.5187 41.5686 24.8061C41.1486 25.0917 40.8256 25.5043 40.5998 26.0437C40.3758 26.5832 40.2619 27.2365 40.2619 28.0037C40.2619 28.8008 40.3758 29.4691 40.6054 30.0067C40.835 30.5443 41.1579 30.9493 41.5742 31.2219C41.9923 31.4944 42.4851 31.6288 43.0582 31.6288C43.3792 31.6288 43.6723 31.5877 43.9355 31.5056C44.2006 31.4235 44.432 31.304 44.6336 31.1453C44.8352 30.9867 45.0014 30.7925 45.1339 30.5648C45.2646 30.3352 45.356 30.0776 45.4064 29.7864L48.3427 29.8032C48.2904 30.3333 48.1355 30.8579 47.8798 31.3749ZM27.9998 51.5088C21.5019 51.5088 15.62 48.8787 11.3603 44.6227L27.9998 28L11.3603 11.3773C15.62 7.12134 21.5019 4.49121 27.9998 4.49121C34.4976 4.49121 40.3795 7.12321 44.6392 11.3773L27.9998 28L44.6392 44.6227C40.3795 48.8787 34.4976 51.5088 27.9998 51.5088ZM8.22244 34.0088V21.9912H13.2382C14.1398 21.9912 14.8939 22.1181 15.5024 22.372C16.111 22.6277 16.5683 22.9824 16.8763 23.4397C17.1843 23.8971 17.3374 24.4272 17.3374 25.0301C17.3374 25.4875 17.2422 25.8963 17.0499 26.2528C16.8576 26.6112 16.5944 26.908 16.2566 27.1413C15.9206 27.3765 15.5304 27.5408 15.088 27.6341V27.7517C15.5734 27.776 16.0232 27.9067 16.4358 28.1456C16.8502 28.3845 17.1806 28.7168 17.4326 29.1405C17.6827 29.5661 17.8078 30.0683 17.8078 30.6451C17.8078 31.2909 17.6435 31.8659 17.315 32.3736C16.9864 32.8795 16.5104 33.2789 15.887 33.5701C15.2635 33.8613 14.5094 34.0069 13.619 34.0069H8.22244V34.0088ZM27.9998 0.959473C13.0515 0.959473 0.933105 13.0648 0.933105 28C0.933105 42.9333 13.0515 55.0405 27.9998 55.0405C42.948 55.0405 55.0664 42.9333 55.0664 28C55.0664 13.0648 42.948 0.959473 27.9998 0.959473ZM13.5854 26.7736C13.8318 26.6672 14.024 26.516 14.164 26.3163C14.3022 26.1165 14.3712 25.8757 14.3712 25.5957C14.3712 25.1925 14.2294 24.8752 13.9419 24.6437C13.6563 24.4123 13.2699 24.2984 12.7846 24.2984H11.1288V26.9323H12.7379C13.0571 26.9323 13.339 26.88 13.5854 26.7736ZM14.5542 29.5101C14.4086 29.2861 14.2032 29.1107 13.9382 28.9875C13.6712 28.8643 13.3539 28.8027 12.9806 28.8027H11.1307V31.6661H12.9283C13.5592 31.6661 14.024 31.5467 14.3246 31.3077C14.6232 31.0688 14.7744 30.7365 14.7744 30.3109C14.7726 30.0029 14.6998 29.736 14.5542 29.5101ZM14.5542 29.5101C14.4086 29.2861 14.2032 29.1107 13.9382 28.9875C13.6712 28.8643 13.3539 28.8027 12.9806 28.8027H11.1307V31.6661H12.9283C13.5592 31.6661 14.024 31.5467 14.3246 31.3077C14.6232 31.0688 14.7744 30.7365 14.7744 30.3109C14.7726 30.0029 14.6998 29.736 14.5542 29.5101ZM13.9438 24.6437C13.6582 24.4123 13.2718 24.2984 12.7864 24.2984H11.1307V26.9323H12.7398C13.0571 26.9323 13.339 26.88 13.5854 26.7736C13.8318 26.6672 14.024 26.516 14.164 26.3163C14.3022 26.1165 14.3712 25.8757 14.3712 25.5957C14.3712 25.1907 14.2294 24.8752 13.9438 24.6437Z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                    </div>
                    <div className="bg-[#053465] h-screen">
                        <div className="flex items-center justify-center h-screen relative">
                            <div className="text-right hidden md723:block">
                                <p
                                    onClick={() =>
                                        navigate("/dashboard-empresas/usuarios")
                                    }
                                    className="text-white font-medium mt-7 mr-10 text-base top-0 right-0 absolute cursor-pointer ">
                                    Salir
                                </p>
                            </div>
                            <div className="text-right  md723:hidden">
                                <svg
                                    onClick={() =>
                                        navigate("/dashboard-empresas/usuarios")
                                    }
                                    className="rounded-full hover:bg-gray-600 hover:text-white text-white font-medium mt-7 ml-7 text-base top-0 left-0 absolute"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M18 6L6 18"
                                        stroke="currentColor"
                                        strokeWidth="1.66667"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M6 6L18 18"
                                        stroke="currentColor"
                                        strokeWidth="1.66667"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </div>
                            <div>
                                <p className="text-white font-medium text-4xl">
                                    Bienvenido a
                                </p>
                                <p className="text-white font-bold text-5xl mt-3">
                                    Blue Corner
                                </p>
                                <div className="mt-5">
                                    <p className="text-white font-normal text-base">
                                        Te ayudaremos en todo el
                                    </p>
                                    <p className="text-white font-normal text-base">
                                        proceso para que tu empresa
                                    </p>
                                    <p className="text-white font-normal text-base">
                                        disfrute de beneficios.
                                    </p>
                                </div>
                                <button
                                    onClick={() => setPage(page + 1)}
                                    className="text-center border-blue-400 bg-blue-bluecorner text-white w-full xs:w-80 border hover:bg-white hover:text-blue-bluecorner p-3 rounded-md text-base mt-5">
                                    ¡Empecemos!
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {page === 1 && (
                <OnboardingLogo
                    page={page}
                    setPage={setPage}
                    empresa={empresa}
                    setEmpresa={setEmpresa}
                />
            )}
            {page === 2 && (
                <OnboardingColor
                    page={page}
                    setPage={setPage}
                    empresa={empresa}
                    setEmpresa={setEmpresa}
                />
            )}
            {page === 3 && (
                <OnboardingTerminado
                    page={page}
                    setPage={setPage}
                    empresa={empresa}
                    setEmpresa={setEmpresa}
                />
            )}
        </div>
    );
};

export default OnboardingBienvenida;
